import { ScrollView, View } from 'dripsy';
import AppSettings from '@inbox-demo-nx/ui-app-settings';

export default function SettingScreen() {
  return (
    <View sx={{ flex: 1, backgroundColor: 'background' }}>
      <ScrollView
        contentInsetAdjustmentBehavior="automatic"
        contentContainerStyle={{ padding: 16 }}
      >
        <AppSettings style={{ marginBottom: 32 }} />
      </ScrollView>
    </View>
  );
}
